import { createFileRoute, redirect } from '@tanstack/react-router';

import { resolveLoginDestination } from '@/lib/auth/resolveLoginDestination';
import { AUTH_ROUTES } from '@/lib/constants';
import { useAuthStore } from '@/stores/authStore';

/**
 * Root `/` has no standalone landing page. Logged-out visitors are always sent
 * to the staff login; authenticated users are forwarded to their role home.
 */
export const Route = createFileRoute('/')({
  beforeLoad: () => {
    const { isAuthenticated, user } = useAuthStore.getState();
    if (!isAuthenticated || !user) {
      // eslint-disable-next-line @typescript-eslint/only-throw-error
      throw redirect({ to: AUTH_ROUTES.STAFF_LOGIN, search: { email: undefined } });
    }
    // eslint-disable-next-line @typescript-eslint/only-throw-error
    throw redirect({ to: resolveLoginDestination(user) as never });
  },
});
